import React from "react";

import { RectSkeleton } from "shipnow-mercurio";

export const OneRectSkeleton = () => {
  return <RectSkeleton size="lg" width="70%" />;
};
